import { MediaData } from '@app/shared/types/player';
import { MediaAction } from '@app/shared/types/pages/settlementDetails';
import { DevelopmentSphere } from '@app/shared/constants/cognition';

export const VIDEO_LIST: MediaData[] = [
  {
    id: 200,
    title: 'visionYoga',
    description: '',
    src: 'https://youtube.com/embed/UdgIBaXp-a4',
    type: 'practice',
  },
  {
    id: 201,
    title: 'yogaSupportPractice',
    description: '',
    src: 'https://youtube.com/embed/cWcnGk-5pSE',
    type: 'practice',
  },
  {
    id: 202,
    title: 'breathBalance',
    description: '',
    src: 'https://youtube.com/embed/gJ1teN8vEYo',
    type: 'practice',
  },
  {
    id: 203,
    title: 'dom',
    description: '',
    src: 'https://youtube.com/embed/uq5ZWl6qDsc',
    type: 'practice',
  },
];

export const AUDIO_LIST: MediaData[] = [
  {
    id: 1, //done
    title: 'home',
    description: '',
    src: 'insights/home',
    sphere: DevelopmentSphere.RELATIONSHIP,
    type: 'insight',
    settlementId: 0,
  },
  {
    id: 2, //done
    title: 'settingUpEntry',
    description: '',
    src: 'meditations/settingUpEntry',
    settlementId: 1,
    type: 'meditation',
    sphere: DevelopmentSphere.PERSONALITY,
  },
  {
    id: 3, //done
    title: 'community',
    description: '',
    src: 'insights/community',
    sphere: DevelopmentSphere.RELATIONSHIP,
    type: 'insight',
    settlementId: 1,
  },
  {
    id: 4, //done
    title: 'freedom',
    description: '',
    src: 'insights/freedom',
    sphere: DevelopmentSphere.PERSONALITY,
    type: 'insight',
    settlementId: 2,
  },
  {
    id: 5, //done
    title: 'instruction',
    description: '',
    src: 'insights/instruction',
    sphere: DevelopmentSphere.MONEY,
    type: 'insight',
    settlementId: 3,
  },
  {
    id: 6, //done
    title: 'subordination',
    description: '',
    src: 'insights/subordination',
    sphere: DevelopmentSphere.RELATIONSHIP,
    type: 'insight',
  },
  {
    id: 7, //done
    title: 'calmness',
    description: '',
    src: 'meditations/calmness',
    sphere: DevelopmentSphere.HEALTH,
    type: 'meditation',
    settlementId: 2,
  },
  {
    id: 8, //done
    title: 'breathOfLife',
    description: '',
    src: 'meditations/breathOfLife',
    type: 'meditation',
    settlementId: 7,
  },
  {
    id: 9, //done
    title: 'returnToYourself',
    description: '',
    src: 'meditations/returnToYourself',
    type: 'meditation',
    settlementId: 3,
  },

  {
    id: 10, //done
    title: 'easeOfAction',
    description: '',
    src: 'meditations/easeOfAction',
    sphere: DevelopmentSphere.ART,
    type: 'meditation',
    settlementId: 4,
  },
  {
    id: 11, //done
    title: 'love',
    description: '',
    src: 'insights/love',
    sphere: DevelopmentSphere.RELATIONSHIP,
    type: 'insight',
    settlementId: 6,
  },
  {
    id: 12, //done
    title: 'danceOfLife',
    description: '',
    src: 'meditations/danceOfLife',
    sphere: DevelopmentSphere.RELATIONSHIP,
    type: 'meditation',
    settlementId: 6,
  },
  {
    id: 13, //done
    title: 'landOfLove',
    description: '',
    src: 'meditations/landOfLove',
    sphere: DevelopmentSphere.MONEY,
    type: 'meditation',
    settlementId: 7,
  },
  {
    id: 14, //done
    title: 'peaceFormula',
    description: '',
    src: 'insights/peaceFormula',
    sphere: DevelopmentSphere.MONEY,
    type: 'insight',
    settlementId: 7,
  },
  {
    id: 15, //done
    title: 'lightOfHealth',
    description: '',
    src: 'meditations/lightOfHealth',
    sphere: DevelopmentSphere.HEALTH,
    type: 'meditation',
    settlementId: 8,
  },
  {
    id: 16, //done
    title: 'consciousness',
    description: '',
    src: 'insights/consciousness',
    sphere: DevelopmentSphere.PERSONALITY,
    type: 'insight',
    settlementId: 8,
  },
  {
    id: 17, //done
    title: 'soundMassage',
    description: '',
    src: 'practices/soundMassage',
    sphere: DevelopmentSphere.HEALTH,
    type: 'practice',
    settlementId: 8,
  },
  {
    id: 18, //done
    title: 'abundance',
    description: '',
    src: 'meditations/abundance',
    type: 'meditation',
  },
  {
    id: 19, //done
    title: 'mastersFocus',
    description: '',
    src: 'meditations/mastersFocus',
    type: 'meditation',
    settlementId: 10,
  },
  {
    id: 20, //done
    title: 'absolute',
    description: '',
    src: 'insights/absolute',
    type: 'insight',
    settlementId: 9,
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 21, //done
    title: 'apperception',
    description: '',
    src: 'insights/apperception',
    type: 'insight',
    settlementId: 4,
  },
  {
    id: 22, //done
    title: 'balance',
    description: '',
    src: 'insights/balance',
    type: 'insight',
    settlementId: 10,
  },
  {
    id: 23, //done
    title: 'closest',
    description: '',
    src: 'insights/closest',
    type: 'insight',
    sphere: DevelopmentSphere.RELATIONSHIP,
  },
  {
    id: 24, //done
    title: 'eternalPeace',
    description: '',
    src: 'insights/eternalPeace',
    type: 'insight',
    sphere: DevelopmentSphere.MISSION,
    settlementId: 16,
  },
  {
    id: 25, //done
    title: 'highestPurpose',
    description: '',
    src: 'insights/highestPurpose',
    type: 'insight',
    sphere: DevelopmentSphere.MISSION,
    settlementId: 15,
  },
  {
    id: 26, //done
    title: 'illusion',
    description: '',
    src: 'insights/illusion',
    type: 'insight',
    settlementId: 11,
  },
  {
    id: 27, //done
    title: 'levels',
    description: '',
    src: 'insights/levels',
    type: 'insight',
    sphere: DevelopmentSphere.MONEY,
  },
  {
    id: 28, //done
    title: 'richness',
    description: '',
    src: 'insights/richness',
    type: 'insight',
    settlementId: 13,
  },
  {
    id: 29, //done
    title: 'vision',
    description: '',
    src: 'insights/vision',
    type: 'insight',
    settlementId: 12,
  },
  {
    id: 30, //done
    title: 'nrisimha',
    description: '',
    src: 'practices/nrisimha',
    type: 'practice',
    settlementId: 9,
  },
  {
    id: 31, //done
    title: 'heartsTreasure',
    description: '',
    src: 'meditations/heartsTreasure',
    sphere: DevelopmentSphere.MONEY,
    type: 'meditation',
    settlementId: 13,
  },
  {
    id: 32,
    title: 'heartHarmony',
    description: '',
    src: 'practices/heartHarmony',
    type: 'practice',
    sphere: DevelopmentSphere.RELATIONSHIP,
  },
  {
    id: 33,
    title: 'manifestationCode',
    description: '',
    src: 'practices/manifestationCode',
    type: 'practice',
    sphere: DevelopmentSphere.ART,
  },
  {
    id: 34,
    title: 'voiceOfTruth',
    description: '',
    src: 'practices/voiceOfTruth',
    type: 'practice',
    sphere: DevelopmentSphere.ART,
  },
  {
    id: 35,
    title: 'portalToUnity',
    description: '',
    src: 'practices/portalToUnity',
    type: 'practice',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 36,
    title: 'shieldOfProtection',
    description: '',
    src: 'practices/shieldOfProtection',
    type: 'practice',
    sphere: DevelopmentSphere.HEALTH,
  },
  {
    id: 37,
    title: 'elixirOfRebirth',
    description: '',
    src: 'practices/elixirOfRebirth',
    type: 'practice',
    sphere: DevelopmentSphere.MONEY,
  },
  {
    id: 38,
    title: 'awakeningOfClearKnowing',
    description: '',
    src: 'practices/awakeningOfClearKnowing',
    type: 'practice',
    sphere: DevelopmentSphere.PERSONALITY,
  },
  //
  // new meditation
  {
    id: 39,
    title: 'Beginning',
    description: '',
    src: 'attunements/1-begining.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.HEALTH,
  },
  {
    id: 40,
    title: 'Communion of Love',
    description: '',
    src: 'attunements/2-communion-of-love.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.RELATIONSHIP,
  },
  {
    id: 41,
    title: 'Communion of Love',
    description: 'Communion of Love',
    src: 'attunements/2-communion-of-love.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.RELATIONSHIP,
  },
  {
    id: 42,
    title: 'True wealth',
    description: 'True wealth',
    src: 'attunements/3-true-wealth.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.PERSONALITY,
  },
  {
    id: 43,
    title: 'Respect woman',
    description: 'Respect woman',
    src: 'attunements/4-respect-woman.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 44,
    title: 'Reference state',
    description: 'Reference state',
    src: 'attunements/5-reference-state.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.PERSONALITY,
  },
  {
    id: 45,
    title: 'Freedom of spirit',
    description: 'Freedom of spirit',
    src: 'attunements/6-freedom-of-spirit.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 46,
    title: 'Light of life',
    description: 'Light of life',
    src: 'attunements/7-light-of-life.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 47,
    title: 'The crown of creation',
    description: 'The crown of creation',
    src: 'attunements/8-the-crown-of-creation.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.HEALTH,
  },
  {
    id: 48,
    title: 'Repentance',
    description: 'Repentance',
    src: 'attunements/9-repentance.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.ART,
  },
  {
    id: 49,
    title: 'Deep diving',
    description: 'Deep diving',
    src: 'attunements/10-deep-diving.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.HEALTH,
  },
  {
    id: 50,
    title: 'Participle of pleasure',
    description: 'Participle of pleasure',
    src: 'attunements/11-participle-of-pleasure.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 51,
    title: 'Consciousness of consent',
    description: 'Consciousness of consent',
    src: 'attunements/12-consciousness-of-consent.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 52,
    title: 'Remember everything',
    description: 'Remember everything',
    src: 'attunements/13-remember-everything.m4a', // битый файл
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 53,
    title: 'Point of the spirit',
    description: 'Point of the spirit',
    src: 'attunements/14-point-of-the-spirit.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 54,
    title: 'I choose life',
    description: 'I choose life',
    src: 'attunements/15-i-choose-life.mp3',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 55,
    title: 'Joy of life',
    description: 'Joy of life',
    src: 'attunements/16-joy-of-life.mp3',
    type: 'meditation',
    sphere: DevelopmentSphere.MISSION,
  },
  {
    id: 56,
    title: 'A Perfect World',
    description: 'A Perfect World',
    src: 'attunements/17-a-perfect-world.mp3',
    type: 'meditation',
    sphere: DevelopmentSphere.PERSONALITY,
  },
  {
    id: 57,
    title: 'Games of the Gods',
    description: 'Games of the Gods',
    src: 'attunements/18-games-of-the-gods.mp3',
    type: 'meditation',
    sphere: DevelopmentSphere.PERSONALITY,
  },
  {
    id: 58,
    title: 'Kingdom of God',
    description: 'Kingdom of God',
    src: 'attunements/19-kingdom-of-god.m4a',
    type: 'meditation',
    sphere: DevelopmentSphere.PERSONALITY,
  },
];

export const MEDIA_LIST: Record<MediaAction, MediaData[]> = {
  audio: AUDIO_LIST,
  video: VIDEO_LIST,
};
